"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["name", "className", "theme", "testId", "disabled", "checkedValue", "uncheckedValue", "isValid", "isDirty", "isFocused", "id", "aria-describedby"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var defaultProps = {
  disabled: false,
  checked: false,
  isFocused: false,
  isDirty: false,
  isValid: true,
  theme: {}
};

/**
 * Displays a toggle switch control. Use Toggle when the option is committed immediately,
 * like a light switch in the real world. Use Checkbox when the option is part of a form
 * that must be submitted. Most Mulesoft forms should not use a Toggle since the the
 * commit model requires a form submission. So, in most cases, use Checkbox.
 */
var Toggle = exports["default"] = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Toggle, _React$Component);
  function Toggle(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Toggle);
    _this = _callSuper(this, Toggle, [props]);
    _this.generatedId = "toggle_".concat(Math.trunc(Math.random() * 10e8));
    _this.state = {
      checked: _this.props.checked || false
    };
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  (0, _createClass2["default"])(Toggle, [{
    key: "handleChange",
    value: function handleChange() {
      var _this$props = this.props,
        disabled = _this$props.disabled,
        onChange = _this$props.onChange;
      var checked = this.state.checked;
      if (disabled) {
        return;
      }
      this.setState({
        checked: !checked
      });
      if (onChange) {
        onChange({
          value: !checked
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        name = _this$props2.name,
        className = _this$props2.className,
        theme = _this$props2.theme,
        testId = _this$props2.testId,
        disabled = _this$props2.disabled,
        checkedValue = _this$props2.checkedValue,
        uncheckedValue = _this$props2.uncheckedValue,
        isValid = _this$props2.isValid,
        isDirty = _this$props2.isDirty,
        isFocused = _this$props2.isFocused,
        id = _this$props2.id,
        ariaDescribedby = _this$props2['aria-describedby'],
        props = (0, _objectWithoutProperties2["default"])(_this$props2, _excluded);
      var toggleId = id || this.generatedId;
      var checked = this.props.checked !== undefined ? !!this.props.checked : this.state.checked;
      var classes = (0, _classnames["default"])(className, theme.toggle, checked && theme.checked, disabled && theme.disabled, isDirty && theme.isDirty, isValid && theme.isValid, !isValid && theme.hasError, isFocused && theme.isFocused);
      var visibleValue = checked ? checkedValue : uncheckedValue;
      delete props.onChange;

      /**
       * Note: We make the checkbox invisible and only show its label, which is
       * where our styling/control appearance is implemented. The label handles
       * turning the checkbox on/off which updates this control's state.
       */
      return /*#__PURE__*/_react["default"].createElement("label", (0, _extends2["default"])({
        className: classes,
        "data-test-id": testId,
        "data-anypoint-component": Toggle.displayName,
        htmlFor: toggleId
      }, props, {
        role: ariaDescribedby && 'presentation'
      }), /*#__PURE__*/_react["default"].createElement("input", {
        id: toggleId,
        name: name,
        type: "checkbox",
        readOnly: true,
        disabled: disabled,
        checked: checked,
        onChange: this.handleChange,
        "data-checked": checked,
        "aria-labelledby": ariaDescribedby
      }), /*#__PURE__*/_react["default"].createElement("div", {
        "data-test-id": testId && "".concat(testId, "-toggle"),
        className: theme.toggleShape
      }), checkedValue && uncheckedValue && !ariaDescribedby ? /*#__PURE__*/_react["default"].createElement("span", {
        className: theme.toggleValue
      }, visibleValue) : null);
    }
  }]);
  return Toggle;
}(_react["default"].Component);
(0, _defineProperty2["default"])(Toggle, "defaultProps", defaultProps);
(0, _defineProperty2["default"])(Toggle, "displayName", 'Toggle');
//# sourceMappingURL=Toggle.js.map